import "./footer.css";

export const AD_DISCLOSURE =
  "This site is supported by advertising. Ads are contextual and never influence the math, defaults, or defaults sources inside the calculator.";

const CURRENT_YEAR = 2026;

export function mountFooter(): HTMLElement {
  const existing = document.getElementById("ror-footer");
  if (existing) existing.remove();

  const footer = document.createElement("footer");
  footer.id = "ror-footer";
  footer.className = "ror-footer";
  footer.innerHTML = `
    <div class="ror-footer__inner">
      <p class="ror-footer__disclosure">${AD_DISCLOSURE}</p>
      <ul class="ror-footer__links">
        <li><a href="/">Calculator</a></li>
        <li><a href="/privacy">Privacy</a></li>
        <li><a href="/terms">Terms</a></li>
        <li>
          <button
            type="button"
            class="ror-footer__cookie"
            data-action="open-consent"
          >Cookie settings</button>
        </li>
      </ul>
      <p class="ror-footer__meta">© ${CURRENT_YEAR} RentOrOwn.info. Independent — no lenders, brokers, or realtors pay us.</p>
    </div>
  `;

  footer.querySelector<HTMLButtonElement>('[data-action="open-consent"]')?.addEventListener(
    "click",
    () => {
      window.rorConsent?.openSettings();
    },
  );

  document.body.append(footer);
  return footer;
}
